<template>
    <div :class="[clientWidth >= 992 ? 'container-list-pc' : 'container-list']">
        <div :class="[clientWidth >= 992 ? 'title-text-pc' : 'title-text']">{{ title }}</div>
        <div :class="[clientWidth >= 992 ? 'detail-item-pc' : 'detail-item']" v-bind:style="{
            backgroundImage: 'url(' + DetailBg + ')',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%'
        }" v-for="item in list">
            <div :class="[clientWidth >= 992 ? 'detail-text-pc' : 'detail-text']">{{ item.name }}</div>
            <div :class="[clientWidth >= 992 ? 'down-text-pc' : 'down-text']">下载</div>
        </div>
    </div>
</template>
<script>
import { DetailBg } from '@/constants/pics';

export default {
    name: 'index',

    components: {},

    data() {
        return {
            title: '',
            clientWidth: 0,
            DetailBg,
            list: [],
            list1: [

            ],
            list2: [

            ],
            list3: [

            ],
        };
    },

    computed: {},

    mounted() {
        // 02
        const { clientWidth } = document.documentElement;
        this.clientWidth = clientWidth;

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                // 02
                const { clientWidth } = document.documentElement;
                this.clientWidth = clientWidth;

                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 100);
            }
        });
    },
    created() {
        this.title = this.$route.query.title;
        if (this.title == '智慧商业') {
            this.list = this.list2;
        } else if (this.title == '智慧园区') {
            this.list = this.list3;
        } else {
            this.list = this.list1;
        }
    },
    methods: {},

    watch: {},
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.container {
    width: 100vw;
    height: 100vh;
}

.container-list-pc {
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
}


.container-list {
    width: 86%;
    margin-left: 7%;
    margin-right: 7%;
}

.title-text-pc {
    color: #000;
    font-size: 36px;
    text-align: center;
    padding: 20px;
}

.title-text {
    color: #000;
    font-size: 24px;
    text-align: center;
    padding: 10px;
}

.detail-item-pc {
    width: 100%;
    height: 320px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

.detail-item {
    width: 100%;
    height: 110px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}

.detail-text {
    width: 100%;
    color: #fff;
    font-size: 26px;
    text-align: center;
}

.detail-text-pc {
    width: 100%;
    color: #fff;
    font-size: 38px;
    text-align: center;
}

.down-text-pc {
    width: 100%;
    color: #fff;
    font-size: 20px;
    padding: 20px;
    text-align: end;
    position: absolute;
    bottom: 0;
}

.down-text {
    width: 100%;
    color: #fff;
    font-size: 12px;
    padding: 8px;
    text-align: end;
    position: absolute;
    bottom: 0;
}

.loading {
    position: fixed;
    bottom: 30px;
    left: 0;
    right: 0;
    letter-spacing: $letter-spacing-lg;

    animation-name: fade;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: ease-out;
}

@keyframes fade {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
